import { Component, Host, h, Prop, Watch } from '@stencil/core';
import { Tags } from '../../helpers/utils/interfaces';

@Component({
  tag: 'cms-tags',
  styleUrl: 'cms-tags.scss',
  shadow: true,
})
export class CmsTags {
  private contentTags: Tags[];
  /**
   * Displayed the Tag Name
   */
  @Prop() tags!: Tags[] | string;

  @Watch('tags')
  private tagsWatcher(newValue: Tags[] | string) {
    if (typeof newValue === 'string') {
      this.contentTags = JSON.parse(newValue);
    }
  }

  private mapTags() {
    return this.contentTags.map((tag: Tags) => {
      const { tagName, targetUrl, seoItem } = tag;
      if (tagName.length > 0 && targetUrl.length > 0) {
        return (
          <span key={targetUrl} class={'content-tag'}>
            <a
              class={'content-tag-link'}
              href={targetUrl}
              title={'#' + tagName}
            >
              #
              <span
                class={'content-tag-name'}
                itemprop={seoItem ? 'articleSection' : null}
              >
                {tagName}
              </span>
            </a>
          </span>
        );
      }
    });
  }

  componentWillLoad() {
    if (this.tags != undefined) {
      this.tagsWatcher(this.tags);
    }
  }

  render() {
    return <Host>{this.tags !== undefined ? this.mapTags():null}</Host>;
  }
}
